<template>
  <div class="">
    <div>
      <div v-cloak>
        <div class="container-fluid px-0 continer-valentine">
          <div class="d-flex flex-column flex-lg-row">
            <div class="col-lg-9 col-xl-7 bg-valentine__wrapper">
              <div class="bg-valentine">
                <div class="valentine-fixed">
                  <img
                    src="@/assets/images/wolf/wolf_family.jpg"
                    alt="wolf family"
                  />
                </div>
                <div class="text-right text-lg-left">
                  <router-link to="/">
                    <img
                      class="app__logo"
                      src="@/assets/images/logo.svg"
                      alt="Logo greenpeace"
                    />
                  </router-link>
                </div>
                <div>
                  <div class="vcontent__wrapper">
                    <div class="d-block vcontent">
                      <div class="">
                        <div class="container mt-2 mt-lg-5 mt-xl-5">
                          <div class="row">
                            <div class="col-12 col-lg-6">
                              <h1 class="v__title">
                                Stwórz walentynkę dla wilków!
                              </h1>
                              <div class="v__text">
                                <b
                                  >Wilki to uczuciowe zwierzęta. Łączą się w
                                  pary na całe życie, dbają o siebie nawzajem i
                                  okazują sobie miłość!</b
                                ><br /><br />
                                Są jednak w niebezpieczeństwie: Unia Europejska
                                chce osłabić ich ochronę. Nie możemy na to
                                pozwolić! Dlatego pokażmy im naszą miłość :)<br /><br />
                                Zadbamy o to, by Twoja walentynka dla wilków
                                dotarła do Ministry Klimatu i Środowiska —
                                to w jej rękach leży bezpieczna przyszłość
                                wilków. Już w marcu ministra może sprzeciwić się
                                osłabieniu ich ochrony w UE.
                              </div>
                            </div>

                            <div class="col-12 col-lg-6">
                              <b-form class="vform">
                                <div class="row">
                                  <div class="col-lg-12">
                                    <b-form-group>
                                      <div class="vform__label">
                                        Wybierz wzór:
                                      </div>

                                      <div class="vform__cardgroup">
                                        <img
                                          v-for="(
                                            imageName, index
                                          ) in imageNames"
                                          :key="index"
                                          @click="selectImage(index)"
                                          :class="{
                                            selected: selectedIndex === index,
                                          }"
                                          class="vform__card"
                                          alt="Card"
                                          :src="
                                            require(`@/assets/images/wolf/${imageName}`)
                                          "
                                        />
                                      </div>
                                    </b-form-group>
                                  </div>
                                  <div class="col-lg-12">
                                    <b-form-group>
                                      <div class="vform__label">
                                        Wyraź swoją miłość do wilków:
                                      </div>
                                      <textarea
                                        id="text"
                                        v-on:click="onClickElement('text')"
                                        autocomplete="family-name"
                                        v-model="form.text"
                                        required
                                        class="form-control"
                                        rows="3"
                                        placeholder="Czego im życzysz?*"
                                        :class="{
                                          'is-invalid': $v.form.text.$error,
                                        }"
                                      />
                                      <div v-if="$v.form.text.$dirty">
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.text.required"
                                        >
                                          <small>Pole wymagane</small>
                                        </div>
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.text.minLength"
                                        >
                                          <small
                                            >Minimalna długość tekstu to 3
                                            znaki</small
                                          >
                                        </div>
                                        <div
                                          class="text-danger"
                                          v-if="!$v.form.text.maxLength"
                                        >
                                          Zbyt długi tekst. Maksymalna długość
                                          to 150 znaków
                                        </div>
                                      </div>
                                    </b-form-group>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-6">
                                    <b-form-group>
                                      <div class="vform__label">
                                        Kto wysyła walentynkę?
                                      </div>
                                      <b-form-input
                                        id="name"
                                        autocomplete="given-name"
                                        v-on:click="onClickElement('name')"
                                        v-model="form.name"
                                        :v="$v.form.name"
                                        required
                                        placeholder="Imię*"
                                        :class="{
                                          'is-invalid': $v.form.name.$error,
                                        }"
                                      ></b-form-input>
                                      <div
                                        v-if="$v.form.name.$dirty"
                                        class="text-danger-name"
                                      >
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.name.required"
                                        >
                                          <small>Pole wymagane</small>
                                        </div>
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.name.minLength"
                                        >
                                          <small>
                                            Minimalna długość imienia to 3 znaki
                                          </small>
                                        </div>
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.name.maxLength"
                                        >
                                          <small>
                                            Zbyt długie imię. Maksymalna długość
                                            to 255 znaków</small
                                          >
                                        </div>
                                      </div>
                                    </b-form-group>
                                  </div>

                                  <div class="col-lg-6">
                                    <div class="vform__label">
                                      Twój adres email:
                                    </div>
                                    <b-form-group>
                                      <b-form-input
                                        id="email"
                                        :v="$v.form.email"
                                        v-model="form.email"
                                        v-on:click="onClickElement('email')"
                                        type="email"
                                        required
                                        placeholder="Email*"
                                        :class="{
                                          'is-invalid': $v.form.email.$error,
                                        }"
                                      ></b-form-input>
                                      <div v-if="$v.form.email.$dirty">
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.email.required"
                                        >
                                          <small
                                            >Pole wymagane - na ten adres
                                            wyślemy Twoją walentynkę</small
                                          >
                                        </div>
                                        <div
                                          class="text-danger text-left"
                                          v-if="!$v.form.email.email"
                                        >
                                          <small>Wpisz poprawny email</small>
                                        </div>
                                      </div>
                                    </b-form-group>
                                  </div>
                                </div>
                                <b-form-group
                                  id="consents"
                                  class="text-left vform__consents"
                                >
                                  <b-form-checkbox-group
                                    v-model="form.consents"
                                    id="consents"
                                    v-on:click="onClickElement('consents')"
                                    class="form__checkboxes"
                                    :class="{
                                      'is-invalid': $v.form.consents.$error,
                                    }"
                                  >
                                    <b-form-checkbox value="1">
                                      <div class="pt-1">
                                        Wyrażam zgodę na informowanie mnie
                                        mailowo o działaniach Greenpeace
                                        związanych z ochroną środowiska, o
                                        projektach i o możliwościach ich
                                        wsparcia.
                                      </div>
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                  <div v-if="$v.form.consents.$dirty">
                                    <div
                                      class="text-danger text-left"
                                      v-if="!$v.form.consents.required"
                                    >
                                      <small
                                        v-html="content.data.form.agreement_7"
                                      ></small>
                                    </div>
                                  </div>
                                </b-form-group>
                                <div class="d-lg-none">
                                  <div
                                    class="vform__box"
                                    v-if="selectedIndex !== null"
                                  >
                                    <img
                                      class="vform__selectedImage"
                                      :src="
                                        require(`@/assets/images/wolf/${imageNames[selectedIndex]}`)
                                      "
                                      alt="Selected card"
                                    />
                                    <div class="vform__outtext">
                                      {{ form.text }}
                                    </div>
                                    <div class="vform__outname">
                                      {{ form.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="text-center">
                                  <div
                                    class="form__submit font-bold d-inline-flex"
                                    @click="onSubmit"
                                  >
                                    <span v-if="!isLoading">Gotowe!</span>
                                    <div>
                                      <span v-if="isLoading" class="formloader">
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form__legal-notice pb-5 lg-pb-0">
                                  <p
                                    v-html="
                                      content.data.form.additional_field_1
                                    "
                                  ></p>
                                  <p
                                    v-html="content.data.form.legalNotice_6"
                                  ></p>
                                </div>
                              </b-form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-xl-5 px-0 text--center valentine-generate">
              <div class="d-none d-lg-block">
                <div class="vform__box" v-if="selectedIndex !== null">
                  <img
                    class="vform__selectedImage"
                    :src="
                      require(`@/assets/images/wolf/${imageNames[selectedIndex]}`)
                    "
                    alt="Selected card"
                  />
                  <div class="vform__outtext">
                    {{ form.text }}
                  </div>
                  <div class="vform__outname">
                    {{ form.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- FOR OPEN PAYU -->
<script></script>

<script>
import axios from "axios";

import {
  email,
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "Form",
  inject: ["content"],
  data() {
    return {
      title: "Formularz",
      imageNames: ["wilki_1.jpg", "wilki_2.jpg", "wilki_3.jpg"],
      selectedIndex: 1,
      windowWidth: 0,
      isLoading: false,
      form: {
        inviteToPay: new URLSearchParams(location.search).get("inviteToPay"),
        inviteToSinglePayment: new URLSearchParams(location.search).get(
          "inviteToSinglePayment"
        ),

        fundraiser: new URLSearchParams(location.search).get("fundraiser"),
        tag: new URLSearchParams(location.search).get("tag"),
        email: "",
        name: "",
        text: "",
        phone: "",
        consents: [],
        contactType: [],
      },
    };
  },
  computed: {},
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255),
        },
        text: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(150),
        },
        consents: {
          required,
        },
      },
    };
  },

  methods: {
    selectImage(index) {
      this.selectedIndex = index;
    },
    onClickElement: function (name) {
      window.trackFormClick(name);
    },

    onSubmit(evt) {
      let onSubmitButton = document.getElementById("onSubmitButton");

      if (onSubmitButton) {
        onSubmitButton.setAttribute("disabled", true);
        setTimeout(() => {
          onSubmitButton.removeAttribute("disabled");
        }, 2000);
      }

      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "formSendError",
          formName: "Formularz",
          errorForm: "1",
        });

        this.validationScrollToError();
        return;
      }
      this.isLoading = !this.isLoading;
      let dataForPayment = this.getDataForPayment();
      let dataForValentine = this.getDataForValentine();
      axios
        .post(
          "https://bogini2.greenpeace.pl/api/v1/mailings/kocham-wilki",
          dataForValentine,
          {
            headers: { crossDomain: true },
          }
        )
        .then((response) => {
          console.log("valentine has been sent");
        })
        .catch((error) => {
          console.log(
            "An error occurred while making the POST request:",
            error
          );
          this.$router.push("/error");
        });
      axios
        .post(
          "https://bogini2.greenpeace.pl/api/v1/lead-campaigns/kocham-wilki/lead",
          dataForPayment,
          {
            headers: { crossDomain: true },
          }
        )
        .then((response) => {
          console.log("get api response");
          this.$router.push("/support");
        })
        .catch((error) => {
          console.log(
            "An error occurred while making the POST request:",
            error
          );
          this.$router.push("/error");
        });
    },

    getDataForPayment() {
      return {
        name: this.form.name,
        email: this.form.email,
        consents: [parseInt(this.form.consents)],
        context: {
          text: this.form.text,
        },
      };
    },
    getDataForValentine() {
      return {
        email: this.form.email,
        parameters: {
          name: this.form.name,
          image: `https://bogini2.greenpeace.pl/api/v1/image-generators/kocham-wilki/images/${
            this.selectedIndex + 10
          }?text=${encodeURIComponent(
            this.form.text + " - " + this.form.name
          )}`,
        },
      };
    },

    validationScrollToError: function () {
      setTimeout(() => {
        if (document.body.clientWidth < 992) {
          let elementsInErrorsName =
            document.getElementsByClassName("text-danger-name");
          if (elementsInErrorsName && elementsInErrorsName.length > 0) {
            let toScrollInputName = document.getElementById("name");
            toScrollInputName.scrollIntoView();
          }
        }
        if (!this.$v.form.text.required) {
          window.errorOnFormField("text", "Pole jest wymagane");
        } else if (!this.$v.form.text.minLength) {
          window.errorOnFormField(
            "text",
            "Minimalna długość tekstu to 3 znaki"
          );
        } else if (!this.$v.form.text.maxLength) {
          window.errorOnFormField(
            "text",
            "Zbyt długi tekst. Maksymalna długość to 155 znaków"
          );
        }
        if (!this.$v.form.name.required) {
          window.errorOnFormField("name", "Pole jest wymagane");
        } else if (!this.$v.form.name.minLength) {
          window.errorOnFormField(
            "name",
            "Minimalna długość imienia to 3 znaki"
          );
        } else if (!this.$v.form.name.maxLength) {
          window.errorOnFormField(
            "name",
            "Zbyt długie imię. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.email.required) {
          window.errorOnFormField("email", "Pole jest wymagane");
        } else if (!this.$v.form.email.email) {
          window.errorOnFormField("email", "Wpisz poprawny email");
        }
        if (!this.$v.form.consents.required) {
          window.errorOnFormField("consents", "Zgoda jest wymagana");
        }
      }, 50);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    showTooltipButonSubFn() {
      this.showTooltipButonSub = false;
    },
  },
  watch: {},

  components: {},
  props: {
    thanks: Boolean,
  },
  /*   mounted() {
    // TODO obrazki
    axios
      .get(
        "https://bogini2.greenpeace.pl/api/v1/image-generators/kocham-wilki",
        {
          headers: { crossDomain: true },
        }
      )
      .then((response) => {
        console.log("obrazki", response);
      });
  }, */
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
